module.exports = __webpack_public_path__ + "static/Oakes-Regular-7b47351db9f6db794483187eca96a0c7.otf";